module.exports = __webpack_public_path__ + "static/12-372efe40fedf6abd6643d96d9e3b0a8f.jpg";